import { FormAnswerByQnID } from '../../../models/FormProps';
import { UserMetadata } from '../../BaseElement';
import { RootElement } from '../../RootElement';
import { BaseDisplayCondition, newBaseDisplayCondition, Op } from '../DisplayCondition';
import { isLevelCode, getLevelDisplayName } from '../../../utils/levels';

export const AudienceMetadataDisplayConditionType = 'DisplayCondition::AudienceMetadata';

export interface AudienceMetadataDisplayCondition extends BaseDisplayCondition {
  header: string;
  value: string | number;
}

export function newAudienceMetadataDisplayCondition(header: string, value: string | null) {
  return {
    ...newBaseDisplayCondition(AudienceMetadataDisplayConditionType),
    header,
    value
  };
}

export function meetsAudienceMetadataDisplayCondition(condition: AudienceMetadataDisplayCondition, root: RootElement, answerByQnID: FormAnswerByQnID, userMetadata: UserMetadata) {
  const { op, header, value } = condition;

  switch (op) {
    case Op.Eq: {
      if (header in userMetadata === false) return false;

      // Normalize v2 level codes to display names for comparison.
      const normalizedValue = isLevelCode(value) ? getLevelDisplayName(value) : value;
      return userMetadata[header] === normalizedValue;
    }
    default:
      return false;
  }
}
